import AsyncStorage from "@react-native-async-storage/async-storage";

const PREFIX = "subscription-alert-until:";

function storageKey(userId: string, alertKey: string): string {
  return `${PREFIX}${userId}:${alertKey}`;
}

function endOfLocalDayMs(): number {
  const d = new Date();
  d.setHours(23, 59, 59, 999);
  return d.getTime();
}

/** True when the user snoozed / dismissed and the suppress window is still active. */
export async function isSubscriptionAlertSuppressed(
  userId: string | undefined,
  alertKey: string,
): Promise<boolean> {
  if (!userId) return false;
  try {
    const raw = await AsyncStorage.getItem(storageKey(userId, alertKey));
    if (!raw) return false;
    const until = Number(raw);
    if (!Number.isFinite(until)) return false;
    if (Date.now() >= until) {
      await AsyncStorage.removeItem(storageKey(userId, alertKey));
      return false;
    }
    return true;
  } catch {
    return false;
  }
}

/** “Remind me later” — hide for N days (default 3). */
export async function snoozeSubscriptionAlert(
  userId: string | undefined,
  alertKey: string,
  days = 3,
): Promise<void> {
  if (!userId) return;
  const until = Date.now() + days * 86_400_000;
  try {
    await AsyncStorage.setItem(storageKey(userId, alertKey), String(until));
  } catch {}
}

/** “X” — hide for the rest of the local calendar day. */
export async function dismissSubscriptionAlertForToday(
  userId: string | undefined,
  alertKey: string,
): Promise<void> {
  if (!userId) return;
  try {
    await AsyncStorage.setItem(
      storageKey(userId, alertKey),
      String(endOfLocalDayMs()),
    );
  } catch {}
}
